import ProductProvider, {has as hasProduct, clear as clearCachedProduct} from './provider'
import {receivedRequestProvider, clearCachedReceivedRequest} from "@core/domain/product/received-request";
import {fromCard as createProductFromCard} from "@core/domain/product/factory";
import ProductBreadcrumbs from "@core/domain/product/breadcrumbs";
import {sentRequestProvider} from "@core/domain/product/sent-request";

const ConcernElementPlacementOrder = {
    TOP_DOWN: 'top_down',
    BOTTOM_TOP: 'bottom_top',

    toArray() {
        return [this.TOP_DOWN, this.BOTTOM_TOP];
    }
};

export {
    ConcernElementPlacementOrder,
    ProductProvider,
    receivedRequestProvider,
    hasProduct,
    clearCachedProduct,
    createProductFromCard,
    clearCachedReceivedRequest,
    sentRequestProvider,
    ProductBreadcrumbs
};
